import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { onBalanceConfig } from './OnBalance.name';

/** オンバランスのENUM */
enum OnBalance {
  /** オンバランス   */
  onBalance = '1',
  /** オフバランス */
  offBalance = '2',
}

const onBalanceMap = new Map([
  ['1', OnBalance.onBalance],
  ['2', OnBalance.offBalance],
]);

const rawValueToOnBalance = rawValueToEnumWithDefault(onBalanceMap, '');

const onBalanceToDisplay = enumToNameWithDefault(OnBalance, onBalanceConfig);

const onBalanceToDisplayWithPrefix = enumToNameWithDefault(OnBalance, onBalanceConfig, true);

export { OnBalance, onBalanceToDisplay, onBalanceToDisplayWithPrefix, rawValueToOnBalance };
